const columnWidths: Record<string, Record<string, number>> = {
    hr: {
        internalAppPropertyId: 130,
        sellerName: 180,
        sellerOib: 120,
        contractType: 150,
        propertyType: 150,
        propertyLocation: 200,
        propertyStreet: 150,
        area: 120,
        price: 120,
        priceM2: 120,
        agencyCommission: 150,
        contractDate: 170,
        actions: 100,
    },
    // Add locale overrides below — only specify columns that differ from hr.
    sl: {},
    en: {},
    de: {},
    it: {},
}

export default columnWidths
